import { message } from 'antd';

const cleanText = (text: string) => text.replace(/\n+/g, ' ').replace(/\s+/g, ' ').trim().replace(/"/g, '""');

const getIndentLevel = (row: Element) => {
  const indentEl = row.querySelector('.ant-table-row-indent');
  if (!indentEl) return 0;

  const match = indentEl.className.match(/indent-level-(\d+)/);
  return match ? parseInt(match[1]) : 0;
};

const extractRowCells = (row: Element) => {
  const cells = row.querySelectorAll('td');
  return Array.from(cells)
    .map((c) => `"${cleanText(c.textContent || '')}"`)
    .join(',');
};

export const convertReportToCSV = (container: HTMLElement, fileName: string) => {
  const tables = container.querySelectorAll('.ant-table');

  if (!tables.length) {
    message.warning('No tables found in report.');
    return;
  }

  let csv = '';

  tables.forEach((table, tableIndex) => {
    // -------- HEADER --------
    const headers = table.querySelectorAll('.ant-table-thead th');

    if (headers.length) {
      const headerRow = Array.from(headers)
        .map((h) => `"${cleanText(h.textContent || '')}"`)
        .join(',');

      csv += headerRow + '\n';
    }

    // -------- BODY --------
    const rows = table.querySelectorAll('.ant-table-tbody > tr');

    rows.forEach((row) => {
      const indent = getIndentLevel(row);

      const prefix = indent === 0 ? '[PARENT]' : `${'  '.repeat(indent)}[CHILD-L${indent}]`;

      const values = extractRowCells(row);

      csv += `${prefix},${values}\n`;
    });

    if (tableIndex < tables.length - 1) csv += '\n\n';
  });

  // -------- DOWNLOAD --------
  const blob = new Blob([csv], {
    type: 'text/csv;charset=utf-8;',
  });

  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.csv`;
  link.click();

  URL.revokeObjectURL(url);
};
